export function waitForGoogletagLoaded(timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
      const interval = 200;
      let waited = 0;
      function check() {
        if (typeof window !== 'undefined' && window.googletag && window.googletag.cmd) {
          resolve();
        } else if (waited >= timeout) {
          reject(new Error('googletag not loaded'));
        } else {
          waited += interval;
          setTimeout(check, interval);
        }
      }
      check();
    });
  }